import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionThreeImagesEightTexts from "hooks/form/blocks/useSectionThreeImagesEightTexts";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionTwoImagesTextsButtonsForm() {
    const { buttonDelete, setFirstImage, setSecondImage, formHook } =
        useSectionThreeImagesEightTexts();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow alignItems={"end"}>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Prima Immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setFirstImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_one.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setFirstImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_one.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-24-12"}>
                                        <h3>Seconda Immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setSecondImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_two.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setSecondImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_two.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.title_1}
                                            setValue={setValue}
                                            path={"text.it.title_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.title_2}
                                            setValue={setValue}
                                            path={"text.it.title_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_1}
                                            setValue={setValue}
                                            path={"text.it.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_label_1}
                                            setValue={setValue}
                                            path={"text.it.button_label_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_url_1}
                                            setValue={setValue}
                                            path={"text.it.button_url_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_label_2}
                                            setValue={setValue}
                                            path={"text.it.button_label_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_url_2}
                                            setValue={setValue}
                                            path={"text.it.button_url_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.title_1}
                                            setValue={setValue}
                                            path={"text.en.title_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.title_2}
                                            setValue={setValue}
                                            path={"text.en.title_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_1}
                                            setValue={setValue}
                                            path={"text.en.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_label_1}
                                            setValue={setValue}
                                            path={"text.en.button_label_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_url_1}
                                            setValue={setValue}
                                            path={"text.en.button_url_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_label_2}
                                            setValue={setValue}
                                            path={"text.en.button_label_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_url_2}
                                            setValue={setValue}
                                            path={"text.en.button_url_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionTwoImagesTextsButtonsForm;
